import React,{useState} from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import './LoadingSpinner.css';

const LoadingSpinner = ({ loading}) => {
    let [color, setColor] = useState("#ffffff");
    const override = {
      display: "block",
      margin: "auto",
      borderColor: "#C99039",
      
    };
    return (
            <div className="sweet-loading">
                <ClipLoader
                    color={color}
                    loading={loading}
                    cssOverride={override}
                    size={100}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
                <p>loading</p>
            </div>
    );
};

export default LoadingSpinner;